import { RoleIds } from '@efexteam/permission-manager';

const ROLES_DESCRIPTIONS = [
  {
    label: 'memberOWNER',
    description: 'roleOwnerDescription',
    value: RoleIds.OWNER,
  },
  {
    label: 'memberPAYMENT_APPROVER',
    description: 'roleApproverDescription',
    value: RoleIds.PAYMENT_APPROVER,
  },
  {
    label: 'memberPAYMENT_ANALYST',
    description: 'teamRoleConfigureDescription',
    value: RoleIds.PAYMENT_ANALYST,
  },
  {
    label: 'memberREAD_ONLY',
    description: 'roleReaderDescription',
    value: RoleIds.READ_ONLY,
  },
  {
    label: 'memberPROMOTER',
    description: 'teamRolePromoterDescription',
    value: RoleIds.PROMOTER,
  },
];

export default ROLES_DESCRIPTIONS;
